import { Gender } from 'src/lib/gql-client'

const genderList: { gender: Gender; label: string }[] = [
  { gender: 'Unspecified', label: '未選択' },
  { gender: 'Male', label: '男性' },
  { gender: 'Female', label: '女性' },
]

export { genderList }
